import React, { useEffect, useRef } from "react";

function NormalTaskFields({ taskDetails }) {
  const textareaRef = useRef(null);
  const urlRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "0px";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }

    if (urlRef.current) {
      urlRef.current.style.height = "0px";
      urlRef.current.style.height = urlRef.current.scrollHeight + "px";
    }
  }, []);

  const titleData = taskDetails.find(
    (x) =>
      x.labeltype?.toLowerCase() === "hot topic type" ||
      x.labeltype?.toLowerCase() === "system update type",
  );

  const fields = taskDetails
    .filter(
      (x) =>
        x.showInMyTaskReview &&
        x.displayType?.toLowerCase() !== "file" &&
        x.labeltype?.toLowerCase() !== "hot topic type" &&
        x.labeltype?.toLowerCase() !== "system update type" &&
        !(
          x.displayType?.toLowerCase() === "multiselect" &&
          x.label?.toLowerCase() === "assigned user"
        ) &&
        !(
          x.displayType?.toLowerCase() === "dropdown" &&
          x.label?.toLowerCase() === "assigned user"
        ),
    )
    .sort((a, b) => a.sumarryOrderBy - b.sumarryOrderBy);

  return (
    <div className="lbls">
      <div className="form-group">
        {titleData && (
          <div className="title_heading">
            <h3>{titleData.labelValue}</h3>
          </div>
        )}
      </div>

      {fields.map((item, index) => {
        if (
          item.labelValue &&
          /^https?:\/\//.test(item.labelValue.replace(" ", ""))
        ) {
          return (
            <div key={index} className="form-group">
              <label>{item.label}</label>
              <div ref={urlRef} className="form-control" id="url-autoresize">
                <a
                  id={`labelvalue_${item.labeltype}`}
                  href={item.labelValue}
                  target="_blank"
                  rel="noreferrer"
                  style={{ cursor: "pointer" }}
                >
                  {item.labelValue}
                </a>
              </div>
            </div>
          );
        }

        if (item.labeltype === "Sub-Behavior" && item.labelValue) {
          const subs = item.labelValue.split("||^||");

          return (
            <div key={index} className="form-group">
              <label>{item.label}</label>

              {subs.map((sub, i) => (
                <input
                  key={i}
                  type="text"
                  className="form-control"
                  value={sub}
                  readOnly
                />
              ))}
            </div>
          );
        }

        if (item.displayType?.toLowerCase() === "textarea") {
          return (
            <div key={index} className="form-group">
              <label>{item.label}</label>
              <textarea
                ref={textareaRef}
                rows="3"
                cols="5"
                className="form-control"
                id="desc-autoresize"
                maxLength="2500"
                value={item.labelValue || ""}
                readOnly
              />
            </div>
          );
        }

        return (
          <div key={index} className="form-group">
            <label>{item.label}</label>
            <input
              type="text"
              id={`labelvalue_${item.labeltype}`}
              className="form-control"
              value={item.labelValue || ""}
              readOnly
            />
          </div>
        );
      })}
    </div>
  );
}

export default NormalTaskFields;
